import React from 'react';

import makePath from '../../utils/makePath';

import { SortableList } from '../Global';
import { Question } from '../PracticeComponents';

export const Path = ({ given = {}, index, ...props }) => {
  const path = makePath(props.path,index);
  return (
    <>
    
      {props.title ? 
        <div className={`path-pill path-pill--header path-pill--${index}`}>{props.title}</div>
      : '' }

      <SortableList
        title={`Path ${index + 1}`}
        label="Question"
        name="questions"
        path={path}
        given={given.questions}
        min={3}
        max={3}
      >
        <Question 
          background
          feedbackForAll
        />
      </SortableList>
    </>
  )

}